import CoreEvent from '@/core/event/coreEvent';

export
default class ApplicationEvent extends CoreEvent {

    static get PAGE_VISIBILITY_CHANGED() {
        return 'ApplicationEvent.pageVisibilityChanged';
    }

    static get VIEW_CHANGED() {
        return 'ApplicationEvent.viewChanged';
    }

    constructor(type, data) {
        super(type, data);
    }
}
